import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';

export function getAdvancedReminderStateOptions(): TSelectOption[] {
  return [
    {
      value: EAdvancedFilterOptions.IS_UPCOMING,
      label: translate('is_upcoming') + '.',
    },
    {
      value: EAdvancedFilterOptions.IS_OVERDUE,
      label: translate('is_overdue') + '.',
    },
    {
      value: EAdvancedFilterOptions.IS_DISMISSED,
      label: translate('is_dismissed') + '.',
    },
  ];
}
